((window, $, App, undefined_) ->
  App.lessonPreview =
    initialize: ->
      return if $(".onLessonsPreviewView").length is 0
      @bindElements()

    bindElements: ->
      $(document).on "click", ".customize-this-lesson", (e) =>
        e.preventDefault()

) window, jQuery, window.App
